import { Provider } from '@angular/core';

import { factoryManageVacationsRepositoryProvider } from '@app/di/repositories/manage-vacations/factory/factory-manage-vacations.repository.provider';
import { momoManageVacationsRepositoryProvider } from '@app/di/repositories/manage-vacations/momo/momo-manage-vacations.repository.provider';

import { auditRepositoryProvider } from './audit/audit.repository.provider';
import { codesRepositoryProvider } from './codes/codes.repository.provider';
import { commentRepositoryProvider } from './comment/comment.repository.provider';
import { contentRepositoryProvider } from './content-translate/content-translate.repository.provider';
import { evaluationRepositoryProvider } from './evaluation/evaluation.repository.provider';
import { geographyRepositoryProvider } from './geography/geography.repository.provider';
import { logisticsManageVacationsRepositoryProvider } from './manage-vacations/logistics/logistics-manage-vacations.repository.provider';
import { motManageVacationsRepositoryProvider } from './manage-vacations/mot/mot-manage-vacations.repository.provider';
import { clockingRepositoryProvider } from './mot/clocking.repository.provider';
import { scheduleRepositoryProvider } from './mot/schedule.repository.provider';
import { signedTimetablesRepositoryProvider } from './mot/signed-timetables.repository.provider';
import { vacationsRepositoryProvider } from './mot/vacations.repository.provider';
import { publicationRepositoryProvider } from './multimedia/publication/publication.repository.provider';
import { videoRepositoryProvider } from './multimedia/video/video.repository.provider';
import { networkRepositoryProvider } from './network/network.repository.provider';
import { notificationRepositoryProvider } from './notification/notification.repository.provider';
import { onBoardingVideoRepositoryProvider } from './on-boarding-video/on-boarding-video.repository.provider';
import { personalDataRepositoryProvider } from './personal-data/personal-data.repository.provider';
import { certificatesRepositoryProvider } from './ptrab/certificates/certificates.repository.provider';
import { documentsRepositoryProvider } from './ptrab/documents/documents.repository.provider';
import { irpfRepositoryProvider } from './ptrab/irpf/irpf.repository.provider';
import { irpfReadjustmentRepositoryProvider } from './ptrab/irpf-readjustment/irpf-readjustment.repository.provider';
import { irsRepositoryProvider } from './ptrab/irs/irs.repository.provider';
import { licensePlatesRepositoryProvider } from './ptrab/license-plates/license-plates.repository.provider';
import { payslipsRepositoryProvider } from './ptrab/payslips/payslips.repository.provider';
import { pdfRepositoryProvider } from './ptrab/pdf/pdf.repository.provider';
import { ptrabSessionRepositoryProvider } from './ptrab/session/session.repository.provider';
import { twoFactorRepositoryProvider } from './ptrab/two-factor/two-factor.repository.provider';
import { withholdingRepositoryProvider } from './ptrab/withholding/withholding.repository.provider';
import { searchRecordRepositoryProvider } from './search/search.repository.provider';
import { staticTextRepositoryProvider } from './static-text/static-text.repository.provider';
import { userRepositoryProvider } from './user/user.repository.provider';

export const getRepositoriesProviders: () => Provider[] = () => [
  personalDataRepositoryProvider,
  userRepositoryProvider,
  staticTextRepositoryProvider,
  searchRecordRepositoryProvider,
  certificatesRepositoryProvider,
  licensePlatesRepositoryProvider,
  documentsRepositoryProvider,
  irpfRepositoryProvider,
  irpfReadjustmentRepositoryProvider,
  irsRepositoryProvider,
  payslipsRepositoryProvider,
  pdfRepositoryProvider,
  ptrabSessionRepositoryProvider,
  twoFactorRepositoryProvider,
  withholdingRepositoryProvider,
  onBoardingVideoRepositoryProvider,
  notificationRepositoryProvider,
  networkRepositoryProvider,
  publicationRepositoryProvider,
  videoRepositoryProvider,
  scheduleRepositoryProvider,
  signedTimetablesRepositoryProvider,
  vacationsRepositoryProvider,
  geographyRepositoryProvider,
  contentRepositoryProvider,
  commentRepositoryProvider,
  auditRepositoryProvider,
  clockingRepositoryProvider,
  motManageVacationsRepositoryProvider,
  factoryManageVacationsRepositoryProvider,
  logisticsManageVacationsRepositoryProvider,
  momoManageVacationsRepositoryProvider,
  evaluationRepositoryProvider,
  codesRepositoryProvider
];
